const aiChatInputStyles = {
  composer: {
    backgroundColor: "action.hover",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "5px",
    margin: { xs: "0.25rem", sm: "0.75rem 1rem" },
    minWidth: 0,
    overflow: "hidden",
    padding: { xs: "0.125rem", sm: "0.5rem" },
    "&:focus-within": {
      borderColor: "primary.main",
    },
  },
};

export default aiChatInputStyles;
